import {PlayerColor} from '@colonist/game-states'
import {ImageURL} from '@colonist/types'
import ShipRedNorthWest from '@static/images/ship_red_north_west.svg'
import ShipBlueNorthWest from '@static/images/ship_blue_north_west.svg'
import ShipOrangeNorthWest from '@static/images/ship_orange_north_west.svg'
import ShipGreenNorthWest from '@static/images/ship_green_north_west.svg'
import ShipBlackNorthWest from '@static/images/ship_black_north_west.svg'
import ShipBronzeNorthWest from '@static/images/ship_bronze_north_west.svg'
import ShipSilverNorthWest from '@static/images/ship_silver_north_west.svg'
import ShipGoldNorthWest from '@static/images/ship_gold_north_west.svg'
import ShipWhiteNorthWest from '@static/images/ship_white_north_west.svg'
import ShipPurpleNorthWest from '@static/images/ship_purple_north_west.svg'
import ShipMysticBlueNorthWest from '@static/images/ship_mysticblue_north_west.svg'
import ShipPinkNorthWest from '@static/images/ship_pink_north_west.svg'

export const SHIP_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: ShipRedNorthWest,
    [PlayerColor.Blue]: ShipBlueNorthWest,
    [PlayerColor.Orange]: ShipOrangeNorthWest,
    [PlayerColor.Green]: ShipGreenNorthWest,
    [PlayerColor.Black]: ShipBlackNorthWest,
    [PlayerColor.Bronze]: ShipBronzeNorthWest,
    [PlayerColor.Silver]: ShipSilverNorthWest,
    [PlayerColor.Gold]: ShipGoldNorthWest,
    [PlayerColor.White]: ShipWhiteNorthWest,
    [PlayerColor.Purple]: ShipPurpleNorthWest,
    [PlayerColor.MysticBlue]: ShipMysticBlueNorthWest,
    [PlayerColor.Pink]: ShipPinkNorthWest,
}
